import { SurveySubmittedTypes } from "../SurveySubmittedTypes";
import images from "../../ImageVariables";
import "../SCSS/styles.css";
function SurveySubmittedPage({ handleViewSubbmission }: SurveySubmittedTypes) {
  return (
    <div className="survey-submitted-page-main-conatiner">
      <div className="survey-submitted-page-main-wrapper">
        <div className="survey-submitted-page-svg-cover">
          <div className="survey-submitted-page-svg-wrapper">
            <img
              className="survey-submitted-page-img"
              src={images.surveySubmitted}
              alt="survey-submitted-page"
            />
          </div>
        </div>
        <div className="survey-submitted-page-header-description-cover">
          <div className="survey-submitted-page-header-text-wrapper">
            <div className="survey-submitted-page-description-text-cover">
              <p className="survey-submitted-page-description">
                Your assessment has already been submitted
              </p>
            </div>
            <div className="survey-submitted-page-header-text-cover">
              <h3 className="survey-submitted-page-header">Thank you</h3>
            </div>
          </div>
          <div className="view-submission-cover">
            <button
              onClick={() => handleViewSubbmission()}
              className="view-subbmission-btn"
            >
              View Submission
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SurveySubmittedPage;
